import { render, staticRenderFns } from "./OrditLayout.vue?vue&type=template&id=f2a4eba4&"
import script from "./OrditLayout.vue?vue&type=script&lang=js&"
export * from "./OrditLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrditLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VSpacer,VToolbarTitle})
